import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Table, Modal, InputNumber } from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import { getResultKPIFinance, addKPIFinance, deleteKPI } from 'api/Project/kpifinance'
import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const AddTaskKPIFinance = (props) => {
  const {
    idEditPRJ,
    visibleDelete,
    setVisibleDelete,
    dataEditTask,
    getResultKpi,
    idKPI,
  } = props

  const language = getCookie('lang')
  const word = lang[language]

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [form] = Form.useForm()

  const onOk = () => {
    const dataArray = {}
    try {
      deleteKPI({
        params: dataArray,
        token: token,
        idKPI: idKPI,
      }).then((response) => {
        if (response.status === 200) {
          setVisibleDelete(false)
          getResultKpi()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Modal
      maskClosable={false}
      className="DeleteModal"
      visible={visibleDelete}
      okText={'Delete'}
      onOk={() => onOk()}
      onCancel={() => setVisibleDelete(false)}
    >
      <CloseCircleOutlined className="CloseCircleOutlined" />
      <h2>{word['Project_KPI/Finance_Delete_title']}</h2>
      <h4>{word['Project_KPI/Finance_Delete_des']}</h4>
    </Modal>
  )
}
export default AddTaskKPIFinance
